import BarbaJs from './_barba/barba.js';
import FancyComponent from "./components/FancyComponent";

window.initGlobal = function() {
    if (window.navigator.userAgent.match(/MSIE|Trident/) !== null){
        $('body').addClass('is-ie');
    }
   
   
    
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.appEvent.resize(() => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        document.documentElement.style.setProperty('--header-height', `${$('header').outerHeight()}px`);
       
       

    }, true).trigger('resize')

    window.fancy = new FancyComponent();
   

};

window.initView = function() {
    window.fancy.initView();
};
$( document ).ready(function() {
    console.log( "ready!" );

});

$(window).on('load', function(){
    window.barba = new BarbaJs();
    window.barba.setDefaultTransition();
    window.barba.init();
    $("body").addClass('loaded');
});
